import { createContext, useContext, useEffect, useState } from "react";

const dict = {
  es: {
    nav_home: "Inicio", nav_menu: "Carta", nav_about: "Sobre Nosotros", nav_blog: "Blog", nav_contact: "Contacto",
    nav_reserve: "Reservar",
    hero_kicker: "Cocina Árabe y Marroquí Auténtica en el Pirineo",
    hero_title_a: "Sabores del mundo árabe en el", hero_title_em: "corazón", hero_title_b: "de La Cerdanya.",
    hero_lead: "Tagines cocinados a fuego lento, cuscús tradicional y el mejor té moruno. En la Plaça del Reg de Puigcerdà.",
    btn_menu: "Ver Carta", btn_wa: "Reservar por WhatsApp", btn_map: "Cómo llegar", btn_maps_open: "Abrir en Google Maps",
    gallery_kicker: "Nuestra Casa", gallery_title: "Un rincón árabe en la Plaça del Reg.",
    gallery_lead: "Cojines con estampado tradicional, mesas de madera, luz cálida. Ven a verlo.",
    impact_a: "Recetas", impact_a_em: "heredadas", impact_b: ". Especias traídas directamente. Y un tagine que habla",
    impact_c_em: "por sí solo", impact_sub: "Algunas cosas no necesitan explicación.",

    philosophy_kicker: "Nuestra Filosofía",
    philosophy_title: "Cocinamos como en casa. Servimos como en familia.",
    philosophy_p1: "En Yasmina no abrimos un restaurante — recuperamos una forma de cocinar. Cada tagine se prepara a fuego lento durante horas en su recipiente de barro original. Las especias llegan directamente de los zocos. El cuscús se trabaja a mano, al vapor, como se ha hecho durante generaciones.",
    philosophy_p2: "No encontrarás microondas en nuestra cocina. No encontrarás atajos. Solo tiempo, producto y el respeto por unas recetas que llevan siglos alimentando familias. Eso es lo que ponemos en cada plato que sale de aquí.",

    essence_kicker: "Lo que nos hace únicos",
    essence_title: "La esencia de la cocina árabe y marroquí.",
    ess1_name: "Tagine de Cordero", ess1_kicker: "Fuego lento · 3 h",
    ess1_desc: "Cordero cocinado lentamente con ciruelas, almendras y especias ras el hanout. Servido en su tagine de barro original.",
    ess2_name: "Cuscús Tradicional", ess2_kicker: "Al vapor · Sémola trabajada a mano",
    ess2_desc: "Sémola al vapor con verduras de temporada, garbanzos y caldo especiado. El plato que une a las familias en Marruecos.",
    ess3_name: "Harira", ess3_kicker: "Sopa tradicional · Especiada",
    ess3_desc: "Tomate, lentejas, garbanzos y cordero en una sopa reconfortante y especiada. La que abre el apetito en cualquier comida.",
    ess4_name: "Té Moruno", ess4_kicker: "Menta fresca · Servido en altura",
    ess4_desc: "Té verde con menta fresca y hierbabuena, servido en altura como manda la tradición. El broche de oro de cada comida.",

    tasting_kicker: "¿Primera vez en Yasmina?",
    tasting_title: "Empieza por el menú degustación.",
    tasting_desc: "Una selección de nuestros platos más emblemáticos para que descubras la cocina árabe y marroquí auténtica. Perfecto para compartir.",
    tasting_btn: "Ver la carta",

    reviews_kicker: "Por qué venir",
    reviews_title: "Cocina árabe y marroquí hecha a fuego lento, cada día.",
    rev1_title: "Recetas de siempre", rev1_text: "Tagines, cuscús y harira cocinados a fuego lento, con especias traídas de Marruecos.",
    rev2_title: "Cocina halal", rev2_text: "Toda la carne es halal, sin cerdo ni alcohol en la cocina, con utensilios dedicados.",
    rev3_title: "Ambiente familiar", rev3_text: "Un rincón árabe en el centro de Puigcerdà, abierto cada día para comer sin prisa.",

    homecontact_kicker: "Fácil de encontrar",
    homecontact_title: "En la Plaça del Reg de Puigcerdà.",
    homecontact_desc: "En pleno centro, a dos minutos del lago. Ven a comer, quédate a cenar.",
    homecontact_visit: "Ven a vernos",
    homecontact_note: "También hacemos comida para llevar. Pregúntanos en el local.",

    carta_kicker: "Nuestra Carta",
    carta_title: "Cocina árabe, plato a plato.",
    carta_lead: "Todos los platos se preparan al momento, con especias importadas y producto de temporada. Cocina halal, casera, sin atajos.",
    carta_note: "Precio medio: desde 10 € por persona",
    carta_cta_kicker: "Reserva tu mesa",
    carta_cta_title: "Ven a probar la cocina árabe de verdad.",

    about_kicker: "Sobre Nosotros",
    about_title: "Una casa árabe en el Pirineo.",
    about_lead: "Yasmina nació con una idea simple: cocinar como se cocina en casa, servir como se sirve en familia, y compartir en Puigcerdà los sabores del mundo árabe que aquí no se encontraban.",
    about_p1: "Somos una familia. Empezamos porque echábamos de menos los sabores de Marrakech, de Fez, de Chaouen — y descubrimos que en La Cerdanya no había un solo sitio donde encontrarlos. Así que montamos el nuestro. Un local pequeño, con lámparas de latón, con vasos de té de colores, con el olor de las especias saliendo por la puerta cada tarde.",
    about_p2: "Cocinamos tagines a fuego lento durante horas. Trabajamos el cuscús a mano. Traemos las especias directamente. Servimos té con menta en altura, como manda la tradición. Y sí — todo es halal, como en nuestra propia casa.",
    about_cta_title: "Te esperamos en la Plaça del Reg.",

    contact_kicker: "Contacto",
    contact_title: "Ven a vernos.",
    hours_title: "Horarios",
    contact_note: "Te esperamos en la Plaça del Reg.",

    footer_tagline: "Cocina árabe y marroquí auténtica en el corazón de La Cerdanya. Tagines, cuscús y té moruno servidos con la calma de una casa.",
    footer_contact: "Contacto",
    footer_nav: "Navegación",
    footer_bottom: "Cocina Árabe y Marroquí en Puigcerdà",
    footer_region: "Puigcerdà · La Cerdanya · Pirineo Catalán",

    notfound_title: "Página no encontrada",
    notfound_lead: "Puede que el enlace haya cambiado.",
    notfound_btn: "Volver al inicio",
  },
  ca: {
    nav_home: "Inici", nav_menu: "Carta", nav_about: "Sobre Nosaltres", nav_blog: "Blog", nav_contact: "Contacte",
    nav_reserve: "Reservar",
    hero_kicker: "Cuina Àrab i Marroquina Autèntica al Pirineu",
    hero_title_a: "Sabors del món àrab al", hero_title_em: "cor", hero_title_b: "de La Cerdanya.",
    hero_lead: "Tagines cuinats a foc lent, cuscús tradicional i el millor te morú. A la Plaça del Reg de Puigcerdà.",
    btn_menu: "Veure Carta", btn_wa: "Reservar per WhatsApp", btn_map: "Com arribar", btn_maps_open: "Obrir a Google Maps",
    gallery_kicker: "La nostra casa", gallery_title: "Un racó àrab a la Plaça del Reg.",
    gallery_lead: "Coixins amb estampat tradicional, taules de fusta, llum càlida. Vine a veure-ho.",
    impact_a: "Receptes", impact_a_em: "heretades", impact_b: ". Espècies portades directament. I un tagine que parla",
    impact_c_em: "per si sol", impact_sub: "Algunes coses no necessiten explicació.",

    philosophy_kicker: "La nostra Filosofia",
    philosophy_title: "Cuinem com a casa. Servim com en família.",
    philosophy_p1: "A Yasmina no vam obrir un restaurant — recuperem una manera de cuinar. Cada tagine es prepara a foc lent durant hores en el seu recipient de fang original. Les espècies arriben directament dels souks. El cuscús es treballa a mà, al vapor, com s'ha fet durant generacions.",
    philosophy_p2: "No trobaràs microones a la nostra cuina. No trobaràs dreceres. Només temps, producte i el respecte per unes receptes que porten segles alimentant famílies. Això és el que posem a cada plat que surt d'aquí.",

    essence_kicker: "El que ens fa únics",
    essence_title: "L'essència de la cuina àrab i marroquina.",
    ess1_name: "Tagine de Xai", ess1_kicker: "Foc lent · 3 h",
    ess1_desc: "Xai cuinat lentament amb prunes, ametlles i espècies ras el hanout. Servit en el seu tagine de fang original.",
    ess2_name: "Cuscús Tradicional", ess2_kicker: "Al vapor · Sèmola treballada a mà",
    ess2_desc: "Sèmola al vapor amb verdures de temporada, cigrons i brou especiat. El plat que uneix les famílies al Marroc.",
    ess3_name: "Harira", ess3_kicker: "Sopa tradicional · Especiada",
    ess3_desc: "Tomàquet, llenties, cigrons i xai en una sopa reconfortant i especiada. La que obre la gana en qualsevol àpat.",
    ess4_name: "Te Morú", ess4_kicker: "Menta fresca · Servit en alçada",
    ess4_desc: "Te verd amb menta fresca i herbabona, servit en alçada com mana la tradició. El colofó de cada àpat.",

    tasting_kicker: "Primera vegada a Yasmina?",
    tasting_title: "Comença pel menú degustació.",
    tasting_desc: "Una selecció dels nostres plats més emblemàtics perquè descobreixis la cuina àrab i marroquina autèntica. Perfecte per compartir.",
    tasting_btn: "Veure la carta",

    reviews_kicker: "Per què venir",
    reviews_title: "Cuina àrab i marroquina feta a foc lent, cada dia.",
    rev1_title: "Receptes de sempre", rev1_text: "Tagines, cuscús i harira cuinats a foc lent, amb espècies portades del Marroc.",
    rev2_title: "Cuina halal", rev2_text: "Tota la carn és halal, sense porc ni alcohol a la cuina, amb estris dedicats.",
    rev3_title: "Ambient familiar", rev3_text: "Un racó àrab al centre de Puigcerdà, obert cada dia per menjar sense presses.",

    homecontact_kicker: "Fàcil de trobar",
    homecontact_title: "A la Plaça del Reg de Puigcerdà.",
    homecontact_desc: "En ple centre, a dos minuts del llac. Vine a dinar, queda't a sopar.",
    homecontact_visit: "Vine a veure'ns",
    homecontact_note: "També fem menjar per emportar. Pregunta'ns al local.",

    carta_kicker: "La nostra Carta",
    carta_title: "Cuina àrab, plat a plat.",
    carta_lead: "Tots els plats es preparen al moment, amb espècies importades i producte de temporada. Cuina halal, casolana, sense dreceres.",
    carta_note: "Preu mitjà: des de 10 € per persona",
    carta_cta_kicker: "Reserva la teva taula",
    carta_cta_title: "Vine a provar la cuina àrab de veritat.",

    about_kicker: "Sobre Nosaltres",
    about_title: "Una casa àrab al Pirineu.",
    about_lead: "Yasmina va néixer amb una idea senzilla: cuinar com es cuina a casa, servir com es serveix en família, i compartir a Puigcerdà els sabors del món àrab que aquí no es trobaven.",
    about_p1: "Som una família. Vam començar perquè trobàvem a faltar els sabors de Marràqueix, de Fes, de Chaouen — i vam descobrir que a La Cerdanya no hi havia ni un sol lloc on trobar-los. Així que vam muntar el nostre. Un local petit, amb llums de llautó, amb gots de te de colors, amb l'olor de les espècies sortint per la porta cada tarda.",
    about_p2: "Cuinem tagines a foc lent durant hores. Treballem el cuscús a mà. Portem les espècies directament. Servim te amb menta en alçada, com mana la tradició. I sí — tot és halal, com a casa nostra.",
    about_cta_title: "T'esperem a la Plaça del Reg.",

    contact_kicker: "Contacte",
    contact_title: "Vine a veure'ns.",
    hours_title: "Horaris",
    contact_note: "T'esperem a la Plaça del Reg.",

    footer_tagline: "Cuina àrab i marroquina autèntica al cor de La Cerdanya. Tagines, cuscús i te morú servits amb la calma d'una casa.",
    footer_contact: "Contacte",
    footer_nav: "Navegació",
    footer_bottom: "Cuina Àrab i Marroquina a Puigcerdà",
    footer_region: "Puigcerdà · La Cerdanya · Pirineu Català",

    notfound_title: "Pàgina no trobada",
    notfound_lead: "Potser l'enllaç ha canviat.",
    notfound_btn: "Tornar a l'inici",
  },
  ar: {
    nav_home: "الرئيسية", nav_menu: "القائمة", nav_about: "من نحن", nav_blog: "المدونة", nav_contact: "اتصل بنا",
    nav_reserve: "احجز",
    hero_kicker: "مطبخ عربي ومغربي أصيل في جبال البيرينيه",
    hero_title_a: "نكهات العالم العربي في", hero_title_em: "قلب", hero_title_b: "لا سيردانيا.",
    hero_lead: "طاجين مطبوخ على نار هادئة، كسكس تقليدي وأفضل شاي بالنعناع. في بلاثا ديل ريج ببويغسردا.",
    btn_menu: "شاهد القائمة", btn_wa: "احجز عبر واتساب", btn_map: "كيفية الوصول", btn_maps_open: "افتح في خرائط جوجل",
    gallery_kicker: "بيتنا", gallery_title: "ركن عربي في بلاثا ديل ريج.",
    gallery_lead: "وسائد بنقوش تقليدية، طاولات خشبية، إضاءة دافئة. تعال لتراه.",
    impact_a: "وصفات", impact_a_em: "موروثة", impact_b: ". بهارات مستوردة مباشرة. وطاجين يتحدث",
    impact_c_em: "عن نفسه", impact_sub: "بعض الأشياء لا تحتاج إلى شرح.",

    philosophy_kicker: "فلسفتنا",
    philosophy_title: "نطبخ كما في البيت. نقدّم كما في العائلة.",
    philosophy_p1: "في ياسمينة لم نفتح مجرد مطعم — بل أحيينا طريقة في الطبخ. كل طاجين يُطهى على نار هادئة لساعات في إنائه الطيني الأصلي. البهارات تصل مباشرة من الأسواق. الكسكس يُحضّر يدويًا وعلى البخار، كما جرت العادة منذ أجيال.",
    philosophy_p2: "لن تجد ميكروويف في مطبخنا. لن تجد اختصارات. فقط الوقت والمنتج الجيد واحترام وصفات أطعمت العائلات لقرون. هذا ما نضعه في كل طبق يخرج من هنا.",

    essence_kicker: "ما يميزنا",
    essence_title: "جوهر المطبخ العربي والمغربي.",
    ess1_name: "طاجين الخروف", ess1_kicker: "نار هادئة · 3 ساعات",
    ess1_desc: "خروف مطهو ببطء مع البرقوق واللوز وبهارات رأس الحانوت. يُقدَّم في طاجينه الطيني الأصلي.",
    ess2_name: "كسكس تقليدي", ess2_kicker: "على البخار · سميد محضّر يدويًا",
    ess2_desc: "سميد على البخار مع خضار الموسم والحمص ومرق متبل. الطبق الذي يجمع العائلات في المغرب.",
    ess3_name: "حريرة", ess3_kicker: "شوربة تقليدية · متبلة",
    ess3_desc: "طماطم وعدس وحمص ولحم خروف في شوربة مريحة ومتبلة. تفتح الشهية في أي وجبة.",
    ess4_name: "أتاي (شاي مغربي)", ess4_kicker: "نعناع طازج · يُصبّ من الأعلى",
    ess4_desc: "شاي أخضر بالنعناع الطازج والحبق، يُصبّ من الأعلى كما تقتضي التقاليد. لمسة ختامية لكل وجبة.",

    tasting_kicker: "أول زيارة لياسمينة؟",
    tasting_title: "ابدأ بقائمة التذوق.",
    tasting_desc: "تشكيلة من أشهر أطباقنا لتكتشف المطبخ العربي والمغربي الأصيل. مثالية للمشاركة.",
    tasting_btn: "شاهد القائمة",

    reviews_kicker: "لماذا تزورنا",
    reviews_title: "مطبخ عربي ومغربي يُطهى على نار هادئة، كل يوم.",
    rev1_title: "وصفات أصيلة", rev1_text: "طاجين وكسكس وحريرة تُطهى على نار هادئة، ببهارات قادمة من المغرب.",
    rev2_title: "مطبخ حلال", rev2_text: "كل اللحوم حلال، دون لحم خنزير أو كحول في المطبخ، وبأدوات مخصّصة.",
    rev3_title: "أجواء عائلية", rev3_text: "ركن عربي في وسط بويغسردا، مفتوح كل يوم للأكل دون عجلة.",

    homecontact_kicker: "سهل الوصول إليه",
    homecontact_title: "في بلاثا ديل ريج ببويغسردا.",
    homecontact_desc: "في وسط المدينة، على بعد دقيقتين من البحيرة. تعال للغداء، وابقَ للعشاء.",
    homecontact_visit: "تعال لزيارتنا",
    homecontact_note: "نقدّم أيضًا طلبات خارجية. اسألنا في المحل.",

    carta_kicker: "قائمتنا",
    carta_title: "مطبخ عربي، طبقًا بطبق.",
    carta_lead: "جميع الأطباق تُحضّر فور الطلب، ببهارات مستوردة ومنتجات موسمية. مطبخ حلال، منزلي، بلا اختصارات.",
    carta_note: "متوسط السعر: من 10 € للشخص",
    carta_cta_kicker: "احجز طاولتك",
    carta_cta_title: "تعال لتجرّب المطبخ العربي الأصيل.",

    about_kicker: "من نحن",
    about_title: "بيت عربي في جبال البيرينيه.",
    about_lead: "وُلدت ياسمينة بفكرة بسيطة: نطبخ كما يُطبخ في البيت، نقدّم كما تُقدَّم الأطباق في العائلة، ونشارك في بويغسردا نكهات العالم العربي التي لم تكن موجودة هنا.",
    about_p1: "نحن عائلة. بدأنا لأننا افتقدنا نكهات مراكش وفاس وشفشاون — واكتشفنا أنه لا يوجد في لا سيردانيا مكان واحد نجدها فيه. فأسّسنا مكاننا الخاص. محل صغير، بمصابيح نحاسية، وأكواب شاي ملوّنة، ورائحة البهارات تفوح من الباب كل مساء.",
    about_p2: "نطبخ الطاجين على نار هادئة لساعات. نحضّر الكسكس يدويًا. نجلب البهارات مباشرة. نقدّم الشاي بالنعناع مصبوبًا من الأعلى كما تقتضي التقاليد. ونعم — كل شيء حلال، تمامًا كما في بيتنا.",
    about_cta_title: "ننتظرك في بلاثا ديل ريج.",

    contact_kicker: "اتصل بنا",
    contact_title: "تعال لزيارتنا.",
    hours_title: "ساعات العمل",
    contact_note: "ننتظرك في بلاثا ديل ريج.",

    footer_tagline: "مطبخ عربي ومغربي أصيل في قلب لا سيردانيا. طاجين وكسكس وشاي بالنعناع يُقدَّم بهدوء بيت حقيقي.",
    footer_contact: "اتصل بنا",
    footer_nav: "روابط",
    footer_bottom: "مطبخ عربي ومغربي في بويغسردا",
    footer_region: "بويغسردا · لا سيردانيا · جبال البيرينيه الكتالونية",

    notfound_title: "الصفحة غير موجودة",
    notfound_lead: "ربما تغيّر الرابط.",
    notfound_btn: "العودة إلى الرئيسية",
  },
};

// Nombres y descripciones de la carta, en el mismo orden que `menu` en data/site.js
// (Tagines[3], Cuscús[2], Entrantes y para compartir[5], Té y Postres[3])
export const menuText = {
  es: {
    cats: ["Tagines", "Cuscús", "Entrantes y para compartir", "Té y Postres"],
    items: [
      ["Tagine de Cordero con Ciruelas y Almendras", "Cordero cocinado lentamente con ciruelas pasas, almendras tostadas y un toque de canela. Servido en su tagine de barro."],
      ["Tagine de Pollo al Limón Confitado", "Pollo tierno con limones confitados y aceitunas verdes. Un clásico de la cocina de Fez."],
      ["Tagine de Verduras de Temporada", "La opción vegetal: berenjenas, calabacín, garbanzos y especias ras el hanout. Sabor pleno sin carne."],
      ["Cuscús Real (Cuscús Royal)", "Sémola al vapor con cordero, pollo, merguez y un caldo especiado con siete verduras. El plato para compartir por excelencia."],
      ["Cuscús de Verduras", "Garbanzos, zanahorias, nabo, calabaza y caldo vegetal especiado. Reconfortante y generoso."],
      ["Briwats de Carne", "Triángulos de masa filo rellenos de carne picada especiada con cebolla y hierbas."],
      ["Harira", "Sopa tradicional de tomate, lentejas, garbanzos y cordero. Reconfortante, especiada, perfecta para empezar."],
      ["Ensalada Marroquí", "Tomate, pepino, cebolla, aceitunas y hierbas frescas con aceite de oliva y limón."],
      ["Zaalouk", "Puré de berenjenas asadas con tomate, ajo y especias. Se come con pan recién hecho."],
      ["Té Moruno con Menta Fresca", "Té verde con hierbabuena servido en altura, como manda la tradición."],
      ["Pastelitos Marroquíes", "Selección de dulces de almendra, miel y agua de azahar. Cuernos de gacela, ghriba y fekkas."],
      ["Baklava", "Capas de masa filo con frutos secos y miel perfumada."],
    ],
  },
  ca: {
    cats: ["Tagines", "Cuscús", "Entrants i per compartir", "Te i Postres"],
    items: [
      ["Tagine de Xai amb Prunes i Ametlles", "Xai cuinat lentament amb prunes seques, ametlles torrades i un toc de canyella. Servit en el seu tagine de fang."],
      ["Tagine de Pollastre a la Llimona Confitada", "Pollastre tendre amb llimones confitades i olives verdes. Un clàssic de la cuina de Fes."],
      ["Tagine de Verdures de Temporada", "L'opció vegetal: albergínies, carbassó, cigrons i espècies ras el hanout. Sabor ple sense carn."],
      ["Cuscús Reial (Cuscús Royal)", "Sèmola al vapor amb xai, pollastre, merguez i un brou especiat amb set verdures. El plat per compartir per excel·lència."],
      ["Cuscús de Verdures", "Cigrons, pastanagues, nap, carbassa i brou vegetal especiat. Reconfortant i generós."],
      ["Briwats de Carn", "Triangles de massa filo farcits de carn picada especiada amb ceba i herbes."],
      ["Harira", "Sopa tradicional de tomàquet, llenties, cigrons i xai. Reconfortant, especiada, perfecta per començar."],
      ["Amanida Marroquina", "Tomàquet, cogombre, ceba, olives i herbes fresques amb oli d'oliva i llimona."],
      ["Zaalouk", "Puré d'albergínies rostides amb tomàquet, all i espècies. Es menja amb pa acabat de fer."],
      ["Te Morú amb Menta Fresca", "Te verd amb herbabona servit en alçada, com mana la tradició."],
      ["Pastissets Marroquins", "Selecció de dolços d'ametlla, mel i aigua de taronger. Banyes de gasela, ghriba i fekkas."],
      ["Baklava", "Capes de massa filo amb fruits secs i mel perfumada."],
    ],
  },
  ar: {
    cats: ["الطاجين", "الكسكس", "المقبلات والمشاركة", "الشاي والحلويات"],
    items: [
      ["طاجين الخروف بالبرقوق واللوز", "خروف مطهو ببطء مع البرقوق المجفف واللوز المحمص ولمسة من القرفة. يُقدَّم في طاجينه الطيني."],
      ["طاجين الدجاج بالليمون المخلل", "دجاج طري مع الليمون المخلل والزيتون الأخضر. طبق كلاسيكي من مطبخ فاس."],
      ["طاجين خضار الموسم", "الخيار النباتي: باذنجان، كوسة، حمص وبهارات رأس الحانوت. نكهة كاملة بدون لحم."],
      ["الكسكس الملكي", "سميد على البخار مع الخروف والدجاج والمرقاز ومرق متبل بسبع خضروات. طبق المشاركة الأمثل."],
      ["كسكس الخضار", "حمص، جزر، لفت، قرع ومرق نباتي متبل. مريح وسخي."],
      ["بريوات باللحم", "مثلثات من عجينة الورقة محشوة بلحم مفروم متبل مع البصل والأعشاب."],
      ["حريرة", "شوربة تقليدية بالطماطم والعدس والحمص ولحم الخروف. مريحة ومتبلة، مثالية للبداية."],
      ["سلطة مغربية", "طماطم، خيار، بصل، زيتون وأعشاب طازجة بزيت الزيتون والليمون."],
      ["زعلوك", "هريس الباذنجان المشوي بالطماطم والثوم والبهارات. يُؤكل مع خبز طازج."],
      ["أتاي بالنعناع الطازج", "شاي أخضر بالحبق يُصبّ من الأعلى، كما تقتضي التقاليد."],
      ["حلويات مغربية", "تشكيلة من حلويات اللوز والعسل وماء الزهر: كعب الغزال، غريبة وفقاص."],
      ["بقلاوة", "طبقات من عجينة الفيلو مع المكسرات وعسل معطر."],
    ],
  },
};

const LangContext = createContext({ lang: "es", setLang: () => {}, t: (k) => k });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("yasmina_lang") || "es");
  useEffect(() => {
    localStorage.setItem("yasmina_lang", lang);
    document.documentElement.lang = lang === "ca" ? "ca-ES" : lang === "ar" ? "ar" : "es-ES";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);
  const t = (k) => (dict[lang] && dict[lang][k]) || dict.es[k] || k;
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
};

export const useT = () => useContext(LangContext);
